// extracted by mini-css-extract-plugin
module.exports = {"switch":"switch_style_switch__2iFIP","selected":"switch_style_selected__2T4lO","unselected":"switch_style_unselected__2YXqP"};